import React from 'react'

const Agreement = () => {
  return (
    <div>Agreement</div>
  )
}

export default Agreement